import React from 'react';

import { SettingsOutline } from '@lyearn/icons';
import { Box, IconButton, Stack, Tooltip } from '@lyearn/ui';
import { Link } from '@/components/Link';
import UserMenu from '@/components/UserMenu';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import KnowledgeBase from '@/modules/knowledge-base-copilot/entry';
import useKnowledgeBaseEnabled from '@/modules/knowledge-base-copilot/hooks/useKnowledgeBaseEnabled';
import routes from '@/pages/corporate/routes';

import NotificationBell from './NotificationBell';

const USER_MENU_OVERRIDES = {
  avatarSize: 32,
  buttonSize: 'small' as const,
  buttonClassname: 'rounded-full',
};

const ICON_BUTTON_RADIUS = 'rounded-8';

const ActionDivider = () => <Box aria-hidden className="h-26 w-1 flex-shrink-0 bg-divider" />;

const UnifiedRightNode = () => {
  const user = useUserContext();
  const isCoachEnabled = useKnowledgeBaseEnabled();

  if (!user.id) {
    return null;
  }

  return (
    <Stack alignItems="center" gap={12}>
      <KnowledgeBase />
      {isCoachEnabled ? <ActionDivider /> : null}
      <Tooltip placement="bottom" title="Settings">
        <IconButton
          Icon={SettingsOutline}
          appearance="secondary"
          aria-label="Settings"
          className={ICON_BUTTON_RADIUS}
          component={Link}
          shape="square"
          size="m"
          to={routes.Settings()}
          variant="outlined"
        />
      </Tooltip>
      <NotificationBell />
      <UserMenu overrides={USER_MENU_OVERRIDES} />
    </Stack>
  );
};

export default React.memo(UnifiedRightNode);
